import { render, staticRenderFns } from "./CardShowDetails.vue?vue&type=template&id=1ee7823c&scoped=true"
import script from "./CardShowDetails.vue?vue&type=script&lang=js"
export * from "./CardShowDetails.vue?vue&type=script&lang=js"
import style0 from "./CardShowDetails.vue?vue&type=style&index=0&id=1ee7823c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7823c",
  null
  
)

export default component.exports